/**
 * Do not edit directly
 * Generated on Tue, 05 Aug 2025 14:28:15 GMT
 */

export const CanvasDefaultInv = "#191C1E";
export const CanvasDefault = "#F7F8F8";
export const Neutral0 = "#ffffff";
export const Neutral100 = "#F7F8F8";
export const Neutral200 = "#F0F1F2";
export const Neutral300 = "#E1E3E4";
export const Neutral400 = "#B4BABD";
export const Neutral500 = "#899296";
export const Neutral600 = "#646F75";
export const Neutral700 = "#41484D";
export const Neutral800 = "#2B3134";
export const Neutral900 = "#191C1E";
export const Neutral1000 = "#0E1113";
export const NeutralBgDefault = "#ffffff";
export const NeutralBgInvDefault = "#0E1113";
export const NeutralBgHover = "#F7F8F8";
export const NeutralBgActive = "#F0F1F2";
export const NeutralBgDisabled = "#B4BABD";
export const NeutralBgWeakDefault = "#F0F1F2";
export const NeutralBgWeakHover = "#E1E3E4";
export const NeutralBgWeakActive = "#B4BABD";
export const NeutralBgWeakDisabled = "#B4BABD";
export const NeutralTxtDefault = "#2B3134";
export const NeutralTxtHover = "#191C1E";
export const NeutralTxtActive = "#0E1113";
export const NeutralTxtDisabled = "#B4BABD";
export const NeutralTxtWeakDefault = "#646F75";
export const NeutralTxtWeakHover = "#41484D";
export const NeutralTxtWeakActive = "#2B3134";
export const NeutralTxtWeakDisabled = "#B4BABD";
export const NeutralTxtStrongDefault = "#0E1113";
export const NeutralTxtStrongHover = "#2B3134";
export const NeutralTxtStrongActive = "#0E1113";
export const NeutralTxtStrongDisabled = "#B4BABD";
export const NeutralTxtInvDefault = "#E1E3E4";
export const NeutralTxtInvHover = "#F0F1F2";
export const NeutralTxtInvActive = "#F7F8F8";
export const NeutralTxtInvDisabled = "#899296";
export const NeutralTxtWeakInvDefault = "#646F75";
export const NeutralTxtWeakInvHover = "#41484D";
export const NeutralTxtWeakInvActive = "#2B3134";
export const NeutralTxtWeakInvDisabled = "#899296";
export const NeutralTxtStrongInvDefault = "#ffffff";
export const NeutralTxtStrongInvHover = "#F0F1F2";
export const NeutralTxtStrongInvActive = "#ffffff";
export const NeutralTxtStrongInvDisabled = "#899296";
export const NeutralIconDefault = "#2B3134";
export const NeutralIconHover = "#191C1E";
export const NeutralIconActive = "#0E1113";
export const NeutralIconDisabled = "#B4BABD";
export const NeutralIconWeakDefault = "#646F75";
export const NeutralIconWeakHover = "#41484D";
export const NeutralIconWeakActive = "#2B3134";
export const NeutralIconWeakDisabled = "#B4BABD";
export const NeutralIconStrongDefault = "#0E1113";
export const NeutralIconStrongHover = "#2B3134";
export const NeutralIconStrongActive = "#0E1113";
export const NeutralIconStrongDisabled = "#B4BABD";
export const NeutralIconInvDefault = "#E1E3E4";
export const NeutralIconInvHover = "#F0F1F2";
export const NeutralIconInvActive = "#F7F8F8";
export const NeutralIconInvDisabled = "#899296";
export const NeutralIconWeakInvDefault = "#646F75";
export const NeutralIconWeakInvHover = "#41484D";
export const NeutralIconWeakInvActive = "#2B3134";
export const NeutralIconWeakInvDisabled = "#899296";
export const NeutralIconStrongInvDefault = "#ffffff";
export const NeutralIconStrongInvHover = "#F0F1F2";
export const NeutralIconStrongInvActive = "#ffffff";
export const NeutralIconStrongInvDisabled = "#899296";
export const NeutralBorderDefault = "#899296";
export const NeutralBorderHover = "#646F75";
export const NeutralBorderActive = "#41484D";
export const NeutralBorderDisabled = "#B4BABD";
export const NeutralBorderWeakDefault = "#89929680";
export const NeutralBorderWeakHover = "#646f7580";
export const NeutralBorderWeakActive = "#41484d80";
export const NeutralBorderWeakDisabled = "#b4babd80";
export const NeutralBorderStrongDefault = "#0E1113";
export const NeutralBorderStrongHover = "#2B3134";
export const NeutralBorderStrongActive = "#0E1113";
export const NeutralBorderStrongDisabled = "#B4BABD";
export const PrimaryBgDefault = "#6046FF";
export const PrimaryBgHover = "#4D38CC";
export const PrimaryBgActive = "#3A2A99";
export const PrimaryBgDisabled = "#DFDAFF";
export const PrimaryBgWeakDefault = "#806BFF";
export const PrimaryBgWeakHover = "#6046FF";
export const PrimaryBgWeakActive = "#BFB5FF";
export const PrimaryBgWeakDisabled = "#DFDAFF";
export const PrimaryTxtDefault = "#4D38CC";
export const PrimaryTxtHover = "#3A2A99";
export const PrimaryTxtActive = "#261C66";
export const PrimaryTxtDisabled = "#DFDAFF";
export const PrimaryTxtWeakDefault = "#6046FF";
export const PrimaryTxtWeakHover = "#4D38CC";
export const PrimaryTxtWeakActive = "#3A2A99";
export const PrimaryTxtWeakDisabled = "#DFDAFF";
export const PrimaryTxtInvDefault = "#EFEDFF";
export const PrimaryTxtInvHover = "#ffffff";
export const PrimaryTxtInvActive = "#ffffff";
export const PrimaryTxtInvDisabled = "#BFB5FF";
export const PrimaryTxtWeakInvDefault = "#ffffff";
export const PrimaryTxtWeakInvHover = "#EFEDFF";
export const PrimaryTxtWeakInvActive = "#ffffff";
export const PrimaryTxtWeakInvDisabled = "#BFB5FF";
export const PrimaryIconDefault = "#4D38CC";
export const PrimaryIconHover = "#3A2A99";
export const PrimaryIconActive = "#261C66";
export const PrimaryIconDisabled = "#DFDAFF";
export const PrimaryIconWeakDefault = "#6046FF";
export const PrimaryIconWeakHover = "#4D38CC";
export const PrimaryIconWeakActive = "#3A2A99";
export const PrimaryIconWeakDisabled = "#DFDAFF";
export const PrimaryIconInvDefault = "#EFEDFF";
export const PrimaryIconInvHover = "#ffffff";
export const PrimaryIconInvActive = "#ffffff";
export const PrimaryIconInvDisabled = "#BFB5FF";
export const PrimaryIconWeakInvDefault = "#ffffff";
export const PrimaryIconWeakInvHover = "#EFEDFF";
export const PrimaryIconWeakInvActive = "#ffffff";
export const PrimaryIconWeakInvDisabled = "#BFB5FF";
export const PrimaryBorderDefault = "#6046FF";
export const PrimaryBorderHover = "#4D38CC";
export const PrimaryBorderActive = "#3A2A99";
export const PrimaryBorderDisabled = "#DFDAFF";
export const PrimaryBorderWeakDefault = "#5f46ff80";
export const PrimaryBorderWeakHover = "#4e38cc80";
export const PrimaryBorderWeakActive = "#3b2a9980";
export const PrimaryBorderWeakDisabled = "#dfdaff80";
export const SuccessBgDefault = "#1C7B30";
export const SuccessBgHover = "#11521E";
export const SuccessBgActive = "#093912";
export const SuccessBgDisabled = "#E7F4E8";
export const SuccessTxtDefault = "#1C7B30";
export const SuccessTxtHover = "#11521E";
export const SuccessTxtActive = "#093912";
export const SuccessTxtDisabled = "#E7F4E8";
export const SuccessTxtInvDefault = "#D2E8D3";
export const SuccessTxtInvHover = "#E7F4E8";
export const SuccessTxtInvActive = "#F3F9F3";
export const SuccessTxtInvDisabled = "#D2E8D3";
export const SuccessIconDefault = "#1C7B30";
export const SuccessIconHover = "#11521E";
export const SuccessIconActive = "#093912";
export const SuccessIconDisabled = "#E7F4E8";
export const SuccessIconInvDefault = "#D2E8D3";
export const SuccessIconInvHover = "#E7F4E8";
export const SuccessIconInvActive = "#F3F9F3";
export const SuccessIconInvDisabled = "#D2E8D3";
export const SuccessBorderDefault = "#289B3F";
export const SuccessBorderHover = "#11521E";
export const SuccessBorderActive = "#093912";
export const SuccessBorderDisabled = "#E7F4E8";
export const CriticalBgDefault = "#CC2A1E";
export const CriticalBgHover = "#8C1810";
export const CriticalBgActive = "#630E08";
export const CriticalBgDisabled = "#FDEDEA";
export const CriticalTxtDefault = "#CC2A1E";
export const CriticalTxtHover = "#8C1810";
export const CriticalTxtActive = "#630E08";
export const CriticalTxtDisabled = "#FDEDEA";
export const CriticalTxtInvDefault = "#FDEDEA";
export const CriticalTxtInvHover = "#FFF6F4";
export const CriticalTxtInvActive = "#ffffff";
export const CriticalTxtInvDisabled = "#FFDAD3";
export const CriticalIconDefault = "#CC2A1E";
export const CriticalIconHover = "#8C1810";
export const CriticalIconActive = "#630E08";
export const CriticalIconDisabled = "#FDEDEA";
export const CriticalIconInvDefault = "#FDEDEA";
export const CriticalIconInvHover = "#FFF6F4";
export const CriticalIconInvActive = "#ffffff";
export const CriticalIconInvDisabled = "#FFDAD3";
export const CriticalBorderDefault = "#CC2A1E";
export const CriticalBorderHover = "#8C1810";
export const CriticalBorderActive = "#630E08";
export const CriticalBorderDisabled = "#FDEDEA";
export const HighlightStrongBgStrong = "#6046FF";
export const HighlightStrongBgWeak = "#DFDAFF";
export const HighlightStrongOnBgStrong = "#ffffff";
export const HighlightStrongOnBgWeak = "#130E33";
export const HighlightStrongBorderStrong = "#6046FF";
export const HighlightStrongBorderWeak = "#DFDAFF";
export const HighlightWeakBgStrong = "#D5F800";
export const HighlightWeakBgWeak = "#F7FECC";
export const HighlightWeakOnBgStrong = "#2B3200";
export const HighlightWeakOnBgWeak = "#2B3200";
export const HighlightWeakBorderStrong = "#D5F800";
export const HighlightWeakBorderWeak = "#F7FECC";
export const HighlightVioletBgStrong = "#6046FF";
export const HighlightVioletBgWeak = "#DFDAFF";
export const HighlightVioletOnBgStrong = "#ffffff";
export const HighlightVioletOnBgWeak = "#130E33";
export const HighlightVioletBorderStrong = "#6046FF";
export const HighlightVioletBorderWeak = "#DFDAFF";
export const HighlightLimeBgStrong = "#D5F800";
export const HighlightLimeBgWeak = "#F7FECC";
export const HighlightLimeOnBgStrong = "#2B3200";
export const HighlightLimeOnBgWeak = "#2B3200";
export const HighlightLimeBorderStrong = "#D5F800";
export const HighlightLimeBorderWeak = "#F7FECC";
export const HighlightOrangeBgStrong = "#FF4A11";
export const HighlightOrangeBgWeak = "#FFDBCF";
export const HighlightOrangeOnBgStrong = "#330F03";
export const HighlightOrangeOnBgWeak = "#330F03";
export const HighlightOrangeBorderStrong = "#FF4A11";
export const HighlightOrangeBorderWeak = "#FFDBCF";
export const HighlightSkyblueBgStrong = "#00D0EC";
export const HighlightSkyblueBgWeak = "#CCF6FB";
export const HighlightSkyblueOnBgStrong = "#002A2F";
export const HighlightSkyblueOnBgWeak = "#002A2F";
export const HighlightSkyblueBorderStrong = "#00D0EC";
export const HighlightSkyblueBorderWeak = "#CCF6FB";
export const HighlightPinkBgStrong = "#E81CEC";
export const HighlightPinkBgWeak = "#FAD2FB";
export const HighlightPinkOnBgStrong = "#2E062F";
export const HighlightPinkOnBgWeak = "#2E062F";
export const HighlightPinkBorderStrong = "#E81CEC";
export const HighlightPinkBorderWeak = "#FAD2FB";
export const Violet0 = "#ffffff";
export const Violet100 = "#EFEDFF";
export const Violet200 = "#DFDAFF";
export const Violet300 = "#BFB5FF";
export const Violet400 = "#A090FF";
export const Violet500 = "#806BFF";
export const Violet600 = "#6046FF";
export const Violet700 = "#4D38CC";
export const Violet800 = "#3A2A99";
export const Violet900 = "#261C66";
export const Violet1000 = "#130E33";
export const Lime0 = "#ffffff";
export const Lime100 = "#FBFEE6";
export const Lime200 = "#F7FECC";
export const Lime300 = "#EEFC99";
export const Lime400 = "#E6FB66";
export const Lime500 = "#DDF933";
export const Lime600 = "#D5F800";
export const Lime700 = "#AAC600";
export const Lime800 = "#809500";
export const Lime900 = "#556300";
export const Lime1000 = "#2B3200";
export const Orange0 = "#ffffff";
export const Orange100 = "#FFEDE7";
export const Orange200 = "#FFDBCF";
export const Orange300 = "#FFB7A0";
export const Orange400 = "#FF9270";
export const Orange500 = "#FF6E41";
export const Orange600 = "#FF4A11";
export const Orange700 = "#CC3B0E";
export const Orange800 = "#992C0A";
export const Orange900 = "#661E07";
export const Orange1000 = "#330F03";
export const Pink0 = "#ffffff";
export const Pink100 = "#FDE8FD";
export const Pink200 = "#FAD2FB";
export const Pink300 = "#F6A4F7";
export const Pink400 = "#F177F4";
export const Pink500 = "#ED49F0";
export const Pink600 = "#E81CEC";
export const Pink700 = "#BA16BD";
export const Pink800 = "#8B118E";
export const Pink900 = "#5D0B5E";
export const Pink1000 = "#2E062F";
export const Skyblue0 = "#ffffff";
export const Skyblue100 = "#E6FAFD";
export const Skyblue200 = "#CCF6FB";
export const Skyblue300 = "#99ECF7";
export const Skyblue400 = "#66E3F4";
export const Skyblue500 = "#33D9F0";
export const Skyblue600 = "#00D0EC";
export const Skyblue700 = "#00A6BD";
export const Skyblue800 = "#007D8E";
export const Skyblue900 = "#00535E";
export const Skyblue1000 = "#002A2F";
export const Green0 = "#ffffff";
export const Green100 = "#F3F9F3";
export const Green200 = "#E7F4E8";
export const Green300 = "#D2E8D3";
export const Green400 = "#8FC693";
export const Green500 = "#289B3F";
export const Green600 = "#1C7B30";
export const Green700 = "#11521E";
export const Green800 = "#093912";
export const Green900 = "#022105";
export const Green1000 = "#021504";
export const Red0 = "#ffffff";
export const Red100 = "#FFF6F4";
export const Red200 = "#FDEDEA";
export const Red300 = "#FFDAD3";
export const Red400 = "#FDA091";
export const Red500 = "#FB3728";
export const Red600 = "#CC2A1E";
export const Red700 = "#8C1810";
export const Red800 = "#630E08";
export const Red900 = "#3E0502";
export const Red1000 = "#290302";
